export {default as AllCandidatesReport} from './AllCandidatesReport.connect';
